import { Portal, Space } from "@thenounproject/lingo-core";

type SpaceAvatars = Pick<Space, "avatars">;
type PortalAvatars = Pick<Portal, "images">;

type Size = "16" | "32" | "48" | "180";

function getPortalAvatar(portal: PortalAvatars, size?: Size) {
  return portal?.images?.avatars?.[`avatar${size ?? ""}`];
}
function getSpaceAvatar(space: SpaceAvatars, size?: Size) {
  return space?.avatars?.[`avatar${size ?? ""}`] || space?.avatars?.defaultAvatar;
}

export default function getAvatar(space: SpaceAvatars, portal: PortalAvatars, size?: Size) {
  return getPortalAvatar(portal, size) ?? getSpaceAvatar(space, size);
}
